var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.523,
    height: 48.13,
    viewBox: "0 0 31.523 48.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1027",
    "data-name": "Groupe 1027",
    transform: "translate(-425.933 -862.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1706",
    "data-name": "Trac\\xE9 1706",
    d: "M457.274,906.816l-7.23-1.344-5.207,5.194-.956-7.292-6.549-3.347,6.64-3.162,1.159-7.263,5.059,5.338,7.265-1.142-3.513,6.461Z",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1707",
    "data-name": "Trac\\xE9 1707",
    d: "M435.026,889.494l-3.63-2.907-4.453,1.343,1.643-4.351-2.653-3.82,4.646.218,2.813-3.7,1.228,4.486,4.392,1.531-3.887,2.554Z",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1708",
    "data-name": "Trac\\xE9 1708",
    d: "M444.352,872.3l-1.858-2.948-3.482-.141,2.229-2.678-.942-3.355,3.236,1.293,2.9-1.933-.23,3.477,2.734,2.16-3.378.856Z",
    fill: "#f6c459"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLeft);
export default __webpack_public_path__ + "static/media/star_left.ff79bd41cac06d0dedc55b535d249a7a.svg";
export { ForwardRef as ReactComponent };